<template>
  <section class="viewsrhqyComplaint_List p-4 space-y-4">
    <viewTitle title="业务管理 / 投诉建议" :showReturn="false" />
    <div class="flex justify-between items-start">
      <el-form :inline="true" :model="queryParam" class="search-form-inline">
        <el-form-item label="状态">
          <el-select
            class="w-32"
            clearable
            v-model="queryParam.state"
            placeholder="请选择状态"
          >
            <el-option
              v-for="(label, value) in stateList"
              :key="value"
              :label="label"
              :value="value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="基地" v-if="baseInfo.is_main_com === 1">
          <el-select class="w-40" placeholder="请选择基地" clearable v-model="queryParam.delivery_com_id">
            <el-option
              v-for="item in com_list"
              :key="item.com_id"
              :label="item.com_name"
              :value="item.com_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            class="!w-96"
            style="margin-bottom: 10px;"
            v-model="timeRange"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="账号">
          <el-input
            clearable
            v-model="queryParam.account"
            placeholder="请输入账号"
            class="w-60"
          ></el-input>
        </el-form-item>
        <el-form-item>
        <el-button type="primary" @click="refreshData" size="small"
        >刷新数据
      </el-button>
      <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
      </el-form>
      <el-button v-has="['c-complaint-list-export']" type="default" @click="onExport" size="small">
        导 出
      </el-button>
    </div>
    <c-table
      class="mt-4"
      :isIndex="false"
      :isSelection="false"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="id"
      @loadPage="loadData"
    >
      <template slot="create_time" slot-scope="{row}">
        {{ row.create_time | timeFormat }}
      </template>
      <template slot="description" slot-scope="{row}">
        <span class="overflow-ellipsis whitespace-nowrap block overflow-hidden">{{ row.description }}</span>
      </template>
      <template slot="action" slot-scope="{ row }">
        <div class="space-x-2">
          <c-link v-has="['c-complaint-list-detail']" @click="onView(row)" label="查看"></c-link>
          <c-link
            v-has="['c-complaint-list-handle']"
            v-if="row.handler_state === 1"
            @click="onHander(row)"
            label="处理"
          ></c-link>
          <c-link v-has="['c-complaint-list-delete']" @click="onDelete(row, 1)" type="danger" label="删除"></c-link>
        </div>
      </template>
    </c-table>
    <ComplaintHandle ref="ComplaintHandle" @ok="refreshData"/>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import { mapGetters } from "vuex";
import ComplaintHandle from './components/ComplaintHandle.vue';
export default {
  props: [""],

  data() {
    return {
      stateList: {
        1: "未处理",
        2: "已处理"
      },
      columns: [
        { width: 160,label: "申请人", prop: "user_name" },
        { width: 160, label: "供应商编号", prop: "unit_code" },
        { width: 160, label: "申请时间", prop: "create_time" },
        {
          width: 160,
          label: "投诉基地",
          prop: "delivery_com_name"
        },
        { label: "投诉建议", prop: "description" },
        {
          width: 160,
          label: "状态",
          prop: "handler_state",
          formatData: row => this.stateList[row.handler_state]
        },
        { width: 160, label: "操作", prop: "action" }
      ],
      fetchDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/query_complaint",
          data: params
        });
      },
      deleteConfig: {
        title: "删除", // 标题
        content: "确认删除？删除后数据将不可恢复！",
        url: "/api/queue/admin/delete_complaint"
      },
      exportDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/export_complaint",
          data: params,
          noLoading: true
        })
      }
    };
  },

  computed: {
    ...mapGetters(["baseInfo"])
  },

  watch: {},

  components: {
    ComplaintHandle
  },

  mixins: [initListMinxin],

  beforeCreate() {},

  created() {},

  beforeMount() {},

  mounted() {},

  activated() {},

  deactivated() {},

  methods: {
    onView(row) {
      this.$router.push({ path: "/rhqy/service/Complaint/Detail/" + row.id });
    },
    onHander(row) {
      this.$refs.ComplaintHandle.onOpen(row);
    }
  }
};
</script>
<style lang="less" scoped></style>
